module.exports = __webpack_public_path__ + "img/exchange-business-card.de94bdca.svg";